import React from 'react';

// Components
import { Text, HStack, VStack, View } from 'native-base';
import { UserListTableViewCell, TableView } from '../../';

// Assets
import { theme } from '@breakroom-nx/assets';

// Classes & Types
import { useGetOnlineTeamMembersQuery } from '@breakroom-nx/redux';

/* eslint-disable-next-line */
export interface HelpPaneProps {}

export function HelpPane(props: HelpPaneProps) {
  const {
    data: teamMembers,
    isLoading,
    isSuccess,
    isError,
    error,
    refetch,
  } = useGetOnlineTeamMembersQuery(undefined);

  const renderMembers = () => {
    if (teamMembers && teamMembers.length > 0) {
      return teamMembers.map((teamMember) => {
        return (
          <UserListTableViewCell friend={teamMember!} key={teamMember!.uid} />
        );
      });
    }
  };

  return (
    <VStack space={5}>
      <View px={8}>
        <VStack space={3}>
          <HStack alignItems={'baseline'} space={3}>
            <Text variant={'headerMini'}>Team Members</Text>
            {teamMembers && teamMembers.length > 0 ? (
              <Text
                fontWeight={700}
                fontSize={16}
                color={theme.colors.surface[400]}
              >
                {teamMembers.length}
              </Text>
            ) : null}
          </HStack>
          <Text color={theme.colors.surface[500]}>
            Feel free to reach out to any of the team members here for help
          </Text>
        </VStack>
        <TableView
          isLoading={isLoading}
          isSuccess={isSuccess}
          isError={isError}
          error={error as string}
          noData={!teamMembers || teamMembers.length < 1}
          noDataString={'No Team Members Available'}
          onRefetch={refetch}
        >
          {renderMembers()}
        </TableView>
      </View>
    </VStack>
  );
}

export default React.memo(HelpPane);
